var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_273_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5008 30H14.5002C12.0191 30 10 27.9813 10 25.5007V15.5633C10 14.0665 10.741 12.6717 11.9831 11.8348L19.4834 6.77463C21.0105 5.74179 22.9885 5.74179 24.5176 6.77463L32.0169 11.8348C33.259 12.6727 34 14.0665 34 15.5633V25.5007C34 27.9813 31.9819 30 29.5008 30ZM22.0005 6.99959C21.3185 6.99959 20.6374 7.20056 20.0434 7.6025L12.5421 12.6617C11.5761 13.3136 11 14.3974 11 15.5623V25.4997C11 27.4294 12.5701 28.9992 14.5002 28.9992H29.5008C31.4309 28.9992 33.001 27.4294 33.001 25.4997V15.5633C33.001 14.3984 32.4249 13.3146 31.4589 12.6627L23.9586 7.6025C23.3636 7.20156 22.6825 6.99959 22.0005 6.99959Z",
    fill: "#A3A3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_273_270",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.58399 0 0 0 0 0.199981 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_270",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4eaf26dd14861e2e185d517aa9f0e952.svg";
export { ForwardRef as ReactComponent };